__turbopack_context__.v({
  "container": "styles-module__d-EJaW__container",
  "cta": "styles-module__d-EJaW__cta",
  "padlock": "styles-module__d-EJaW__padlock",
  "textBody": "styles-module__d-EJaW__textBody",
  "title": "styles-module__d-EJaW__title",
});
